export default __webpack_public_path__ + "static/media/repartidor-provedor.b5f73206.png";